import type React from 'react';

export const accountActionIconStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '24px',
    minHeight: '24px',
    padding: 0,
    border: 'none',
    background: 'transparent',
    color: 'var(--weka-link-color)',
    textDecoration: 'none',
    boxShadow: 'none',
};

export const accountActionIconGroupStyle: React.CSSProperties = {
    display: 'flex',
    gap: '14px',
    flexWrap: 'wrap',
    alignItems: 'center',
};
